import topic from "common/managers/topic";
import Message from "common/enums/main/Message";
import userSettings from "common/managers/userSettings";
import UserSettingNames from "common/enums/settings/UserSettingNames";
export default {

    // setting handler
    _wordWrapSettingHandler: undefined,

    /**
     * Initialize word wrap support.
     */
    initWordWrap: function() {
        if (!this.isWordWrap()) {
            this.element.addClass("noWrapGrid");
        }
        this._wordWrapSettingHandler = topic.subscribe(Message.USER_SETTING_CHANGED, $.proxy(this._wordWrapChange, this));
    },

    /**
     * Destroy word wrap support.
     */
    destroyWordWrap: function() {
        topic.unsubscribe(this._wordWrapSettingHandler);
    },

    /**
     * Determine whether word wrap is currently enabled.
     *
     * @returns {boolean} true if word wrap is enabled, otherwise false
     * @protected
     */
    isWordWrap: function() {
        return userSettings.getBoolean(UserSettingNames.WORD_WRAP_IN_GRIDS, false);
    },

    /**
     * Handle word wrap change event.
     *
     * @param settings user settings
     * @private
     */
    _wordWrapChange: function(settings) {
        if (settings.indexOf(UserSettingNames.WORD_WRAP_IN_GRIDS) > -1) {
            if (this.isWordWrap()) {
                this.element.removeClass("noWrapGrid");
            } else {
                this.element.addClass("noWrapGrid");
            }
        }
    }

};